export default __webpack_public_path__ + "static/css-filter-banner-08ad7d75b0b2e5ed2119905876ea6af9.gif";